module.exports = "https://coursera_assets.s3.amazonaws.com/images/69d8ea80862aa0ad251afa8bff2a6351.png";